/* Search-result route hint — "Customizable | + Muxía route" (2026-10-08).
 *
 * A Customiser product offers several routes on one product, and search finds
 * it by a route's name (the GPX app mirrors each route name into a product
 * tag). The card's poster still shows the default route, so a customer who
 * searched "Muxía" sees a Camino ending in Santiago and has no idea why it
 * came up. This names the matched route inside the card's quiet mark — option
 * B of mockups/2026-10-08_search-route-hint.html, Jay and Maud's pick, with a
 * long name cut off by an ellipsis rather than wrapped (their call too).
 *
 * WHERE THE NAMES COME FROM. Not the tags: a tag cannot say who wrote it, and
 * Way of Saint Francis carries Maud's own "Camino" tag, which would have read as
 * a route. The GPX app writes the active route names to `tyt.route_labels`, and
 * tyt-product-card.liquid prints them on the card as data-route-labels. Only a
 * card with that attribute and the Customizable mark can show a hint.
 *
 * WHEN IT SHOWS. Only when the search needed a route name to match. Every term
 * the trail's own name already explains is set aside first, so "camino" on the
 * Camino de Santiago shows nothing (the customer knows why that came up), while
 * "camino muxia" shows Muxía. If several route names fit, the shortest wins,
 * so "muxia" names "+ Muxía" rather than "+ Finisterre & Muxía".
 *
 * WHAT IT SAYS. The route name minus the words it shares with the trail's name:
 * "Camino Francés + Muxía" on the Camino de Santiago (Camino Francés) prints
 * "Muxía", and "+" between two places reads "&".
 *
 * Two callers: the search results page (main-search.liquid marks its grid with
 * data-tyt-route-hint-q, handled on load below) and the Trail Posters search
 * (tyt-collection-filter.js calls window.TytRouteHint.apply on every render).
 */
(function () {
  'use strict';

  /* ⚠ The SAME separator set as tyt-collection-filter.js, so a word here is a
   * word there. scripts/test-route-hint.js fails if the two ever differ. */
  var SEP = /[\s \-‐-―_/\\.,;:!?'"‘’“”()\[\]{}·•|+&@#*~^%$=<>]+/;

  function startsWith(s, p) { return s.lastIndexOf(p, 0) === 0; }

  /* Accents are folded on both sides, so "muxia" finds "Muxía" — customers
   * rarely type the accent. */
  function fold(s) {
    s = String(s || '').toLowerCase();
    return s.normalize ? s.normalize('NFD').replace(/[̀-ͯ]/g, '') : s;
  }

  function words(s) {
    return fold(s).split(SEP).filter(function (w) { return w.length > 0; });
  }

  function anyStarts(list, term) {
    for (var i = 0; i < list.length; i++) if (startsWith(list[i], term)) return true;
    return false;
  }

  /* What the mark should say after the "+ ", or '' for no hint. */
  function hintFor(labels, ownName, query) {
    var terms = words(query);
    var own = words(ownName);
    var routeTerms = terms.filter(function (t) { return !anyStarts(own, t); });
    if (!routeTerms.length || !labels || !labels.length) return '';

    var best = '';
    for (var i = 0; i < labels.length; i++) {
      var lw = words(labels[i]);
      var all = routeTerms.every(function (t) { return anyStarts(lw, t); });
      if (all && (!best || labels[i].length < best.length)) best = labels[i];
    }
    if (!best) return '';

    /* Drop the words the route shares with the trail's name, then any
     * connector left dangling at either end. */
    var ownSet = {};
    own.forEach(function (w) { ownSet[w] = true; });
    var kept = best.split(/\s+/).filter(function (tok) {
      var w = words(tok);
      return !(w.length === 1 && ownSet[w[0]]);
    });
    while (kept.length && /^[+&\-–—/|·]+$/.test(kept[0])) kept.shift();
    while (kept.length && /^[+&\-–—/|·]+$/.test(kept[kept.length - 1])) kept.pop();
    var text = kept.length ? kept.join(' ') : best;
    text = text.replace(/\s\+\s/g, ' & ');
    /* "Silver Route" must not become "Silver Route route". */
    var last = words(text).pop();
    return last === 'route' ? text : text + ' route';
  }

  /* Show or clear the hint on one card for one query. Safe on any card: one
   * without route names or without the mark is left alone. */
  function apply(card, query) {
    var raw = card.getAttribute && card.getAttribute('data-route-labels');
    if (!raw) return;
    var slot = card.querySelector('[data-tyt-route-hint]');
    var div = card.querySelector('[data-tyt-route-hint-div]');
    if (!slot) return;
    var labels;
    try { labels = JSON.parse(raw); } catch (e) { return; }
    var text = hintFor(labels, card.getAttribute('data-route-own'), query);
    slot.textContent = text ? '+ ' + text : '';
    slot.hidden = !text;
    if (div) div.hidden = !text;
  }

  window.TytRouteHint = { apply: apply, hintFor: hintFor };

  function initSearchPage() {
    var grids = document.querySelectorAll('[data-tyt-route-hint-q]');
    for (var i = 0; i < grids.length; i++) {
      var q = grids[i].getAttribute('data-tyt-route-hint-q') || '';
      var cards = grids[i].querySelectorAll('[data-route-labels]');
      for (var j = 0; j < cards.length; j++) apply(cards[j], q);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearchPage);
  } else {
    initSearchPage();
  }
})();
